import { ConsoleCJ } from '@/pages/Error/Console';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { useEffect } from 'react';

export const Error = ({ error }: { error: Error }) => {
  useEffect(() => {
    ConsoleCJ.customError('ReportingToolsScreen', {
      ...error,
    });
  }, [error]);
  return (
    <div className="flex w-full flex-col items-center justify-center rounded-lg border border-red-200  p-6 text-center">
      <div className="mb-4 text-4xl text-red-500">
        <ExclamationCircleIcon className="size-10" />
      </div>
      <h2 className="mb-2 text-xl font-semibold text-red-800">Something went wrong</h2>
      <p className="text-red-600">We encountered an unexpected error. Please try again later.</p>
    </div>
  );
};
